import { useParams } from "react-router-dom";
import EmailTemplatesService from "../../../services/EmailTemplatesService";
import { ContactUs, EmailTemplate } from "../../../models";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import ContactUsService from "../../../services/ContactUsService";
import ContactUsForm from "./ui/ContactUsForm";
import ContactUsFormSkeleton from "./skeletons/ContactUsFormSkeleton";
 
export default function ContactUsEditPage(){
     const { id } = useParams();
      const api = new ContactUsService();
      const [message, setMessage] = useState<ContactUs>();
      const [loading, setLoading] = useState(true);
      useEffect(() => { 
        fetchMessage();
      }, []);
      console.log({id})
      const fetchMessage = async () => {
        if (id) {
          const data = await api.getContactUsById(id); // Placeholder for fetched features
          setMessage(data);
          setLoading(false);
          
        }
      };

      if (!message && !loading) return <NotFound message="Message not found." />;
    
      return (
        <main className="max-w-3xl ">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Contact Us", href: "/admin/contact-us" },
              {
                label: "Edit",
                href: `/admin/contact-us/edit/${id}`,
                active: true,
              },
            ]}
          />
          {!loading && message ? (
            <ContactUsForm message={message} />
          ) : (
            <ContactUsFormSkeleton />
          )}
        </main>
      );
    }
    